/**
 * We have several elements spread out across several components that need to stack in a specific order.
 * This object defines the z-index values for those elements to ensure they stack correctly and creates
 * a single source of truth and context for these values.
 */
export const Z_INDEX_ORDERS = {
  EDIT_SUBJECT_PLAN: {
    /**
     * The main navigation menu that appears on the left side of the screen.
     * We need to ensure this doesn't get covered by the footer action bar.
     */
    SIDE_MENU: "z-10",

    /**
     * The sticky column headers at the top of the planner table.
     */
    FILTER_DROPDOWN: 8,

    /**
     * The sticky column headers at the top of the planner table.
     */
    STICKY_COLUMN_HEADERS: "z-8",

    /**
     * The sticky row headers on the far left of the planner table.
     */
    STICKY_ROW_HEADERS: "z-5",

    /**
     * The action bar stuck to the bottom of the screen.
     */
    FOOTER_ACTIONS: "z-5",

    /**
     * The draggable handle that appears on the left and right of a unit card.
     * We need this to appear above the card, but below everything else.
     */
    DRAGGABLE_HANDLE: "z-1",
  },
} as const;
